import { lazy, Suspense, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { BottomNav } from "@/components/BottomNav";
import { PushPrompt } from "@/components/PushPrompt";
import { DesktopNav } from "@/components/DesktopNav";
import axios from "axios";
import { API } from "@/lib/api";
import { registerSW } from "@/lib/push";
import { Loader } from "@/components/common";
import Home from "@/pages/Home";
import Events from "@/pages/Events";
const EventDetail = lazy(() => import("@/pages/EventDetail"));
const Reservations = lazy(() => import("@/pages/Reservations"));
const CreateInstant = lazy(() => import("@/pages/CreateInstant"));
const Account = lazy(() => import("@/pages/Account"));
const Experiences = lazy(() => import("@/pages/Experiences"));
const Admin = lazy(() => import("@/pages/Admin"));
const AccountInfo = lazy(() => import("@/pages/AccountPages").then((m) => ({ default: m.AccountInfo })));
const AccountRequests = lazy(() => import("@/pages/AccountPages").then((m) => ({ default: m.AccountRequests })));
const AccountNotifications = lazy(() => import("@/pages/AccountPages").then((m) => ({ default: m.AccountNotifications })));
const PaymentSuccess = lazy(() => import("@/pages/Payment").then((m) => ({ default: m.PaymentSuccess })));
const PaymentCancel = lazy(() => import("@/pages/Payment").then((m) => ({ default: m.PaymentCancel })));
const SignInPage = lazy(() => import("@/pages/AuthPages").then((m) => ({ default: m.SignInPage })));
const SignUpPage = lazy(() => import("@/pages/AuthPages").then((m) => ({ default: m.SignUpPage })));
const PasswordResetPage = lazy(() => import("@/pages/AuthPages").then((m) => ({ default: m.PasswordResetPage })));

const visitorId = () => {
  let v = localStorage.getItem("etm-visitor");
  if (!v) { v = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`; localStorage.setItem("etm-visitor", v); }
  return v;
};

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    if (!pathname.startsWith("/admin")) axios.post(`${API}/track`, { visitor_id: visitorId(), path: pathname }).catch(() => {});
  }, [pathname]);
  return null;
};

const MobileShell = () => (
  <div className="safe-top min-h-screen w-full bg-[#090806]">
    <DesktopNav />
    <main className="mx-auto w-full max-w-[430px] pb-[env(safe-area-inset-bottom)] md:max-w-6xl md:pb-0 md:px-24 xl:px-4">
    <Suspense fallback={<Loader />}>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/events" element={<Events />} />
      <Route path="/events/:id" element={<EventDetail />} />
      <Route path="/reservations" element={<Reservations />} />
      <Route path="/instant" element={<CreateInstant />} />
      <Route path="/account" element={<Account />} />
      <Route path="/account/info" element={<AccountInfo />} />
      <Route path="/account/requests" element={<AccountRequests />} />
      <Route path="/account/notifications" element={<AccountNotifications />} />
      <Route path="/experiences" element={<Experiences />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/sign-in/*" element={<SignInPage />} />
      <Route path="/sign-up/*" element={<SignUpPage />} />
      <Route path="/mot-de-passe/*" element={<PasswordResetPage />} />
      <Route path="*" element={<Home />} />
    </Routes>
    </Suspense>
    </main>
    <BottomNav />
    <PushPrompt />
  </div>
);

function App() {
  useEffect(() => { registerSW(); }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <ClerkAuthProvider>
          <ScrollTop />
          <div data-testid="camera-safe-zone" className="pointer-events-none fixed inset-x-0 top-0 z-[55] h-[var(--safe-top)] bg-[#090806]" />
          <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/admin/*" element={<Admin />} />
            <Route path="/*" element={<MobileShell />} />
          </Routes>
          </Suspense>
          <Toaster position="top-center" offset="calc(var(--safe-top) + 12px)" theme="dark" toastOptions={{ style: { background: "#110d09", border: "1px solid rgba(230,164,93,0.4)", color: "#F7F4EE", fontFamily: "Montserrat" } }} />
        </ClerkAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
